import React from 'react';
import { createPortal } from 'react-dom';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

const FullScreenLoader = ({
    open,
    message = 'Chargement...',
    progressProps = {}
}) => {
    if (!open) {
        return null;
    }

    return createPortal(
        (
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: 99999, // Z-index très élevé pour être au-dessus de tout, y compris les erreurs
                    backdropFilter: 'blur(10px)'
                }}
                open={open}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2,
                        textAlign: 'center'
                    }}
                >
                    <CircularProgress color="inherit" size={56} thickness={4} {...progressProps} />
                    <Typography variant="h6" component="p" sx={{ fontWeight: 500 }}>
                        {message}
                    </Typography>
                </Box>
            </Backdrop>
        ),
        document.body
    );
};

export default FullScreenLoader;

